import React, { useEffect } from 'react'
import { SocketContext, socket } from '../context/SocketContext'
import logger from '../shared/logger'

const SocketProvider = ({ children }) => {
  useEffect(() => {
    if (!window.sessionStorage.getItem('handle')) {
      logger.log('sending handshake')
      socket.emit('handshake')
    } else {
      logger.log('sending renegotiate')
      socket.emit('renegotiate', window.sessionStorage.getItem('handle'))
    }
    socket.on('handshake:request', () => {
      if (window.sessionStorage.getItem('handle')) {
        logger.log('sending renegotiate')
        socket.emit('renegotiate', window.sessionStorage.getItem('handle'))
      } else {
        logger.log('sending handshake')
        socket.emit('handshake')
      }
    })

    socket.on('handshake', (response) => {
      logger.log('processing handshake')
      if (response.force) {
        window.sessionStorage.setItem('handle', response.handle)
      } else if (window.sessionStorage.getItem('handle')) {
        socket.emit('renegotiate', window.sessionStorage.getItem('handle'))
      } else {
        window.sessionStorage.setItem('handle', response.handle)
      }
    })
    socket.on('renegotiated', (response) => {
      logger.log('processing renegotiated')

      if (!response) {
        socket.emit('handshake')
      }
    })
  }, [])

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  )
}

export default SocketProvider
